import React, { useState } from "react";
import { useSellerAuth } from "../../context/SellerAuthContext";
import { useNavigate } from "react-router-dom";

const EmailInputStep = () => {
  const { registrationData, setRegistrationData } = useSellerAuth();
  const [email, setEmail] = useState(registrationData.email);
  const navigate = useNavigate();

  const handleNext = () => {
    setRegistrationData({ ...registrationData, email });
    navigate("/register/password");
  };

  return (
    <div className="p-4">
      <h1 className="text-xl">Enter your email</h1>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full p-2 mt-2 border rounded"
      />
      <button
        onClick={handleNext}
        className="mt-4 p-2 bg-blue-500 text-white rounded"
      >
        Next
      </button>
    </div>
  );
};

export default EmailInputStep;
